<template>
  <div id="app" :class="this.$i18n.locale == 'en' ? 'appen' : ''" v-loading.fullscreen.lock="fullscreenLoading">
    <Header ref="Header" />
    <el-main>
      <router-view />
    </el-main>
     <Footer />
    <!--<el-backtop style="
        background-color: #00bebe;
        color: #fff;
        width: 50px;
        height: 50px;
      "></el-backtop> -->
  </div>
</template>

<script>
import Header from './components/header'
import Footer from './components/Footer'
import Backtop from 'element-ui'

export default {
  components: {
    Header,
    Footer,
    Backtop
  },
  data() {
    return {
      isShow: false,
      fullscreenLoading: true
    };
  },
  watch: {
  },
  mounted() {
    setTimeout(() => {
      this.fullscreenLoading = false;
    }, 3000);
  },
  methods: {
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

@font-face {
  font-family: 'Raleway';
  src: url('style/raleway.ttf');
}

html,
body {
  height: 100%;
  background-color: #fff;
}

body::-webkit-scrollbar {
  width: 0px;
  /*height: 4px;*/
}

#app {
  // font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-family: "Helvetica Neue", Helvetica, Arial, "Microsoft YaHei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;

    img {
      width: 100%;
      line-height: 60px;
    }
  }
}

.el-main {
  min-height: 100vh;
  padding: 102px 0 0 0 !important;
  overflow: hidden !important;
}
@media only screen and (max-width: 767px) {
.el-main {
  padding: 82px 0 0 0 !important;
}
}
</style>
